import React, { Fragment } from 'react'
import { Link } from 'gatsby'
import * as styles from './LinkList.module.scss'
import useLazyLoadComponent from './../../../../hooks/useLazyLoadComponent'
import { Icon } from '@iconify/react'
import SocialMedia from '../../../UI/SocialMedia/SocialMedia'

const LazyComponentSearch = ({ location, nameofClass }) => {
  const LazyLoadSearch = useLazyLoadComponent(location, nameofClass)
  return LazyLoadSearch
}

const SocialLinkList = ({ notSitemap = true }) => {
  return (
    <Fragment>
      <div>
        <ul className={`${styles.navlist}`}>
          {!notSitemap ? (
            <li>
              <Link to="/careers/">
                <Icon
                  className={`${styles.nav_icon}`}
                  icon="uil:briefcase"
                  inline={true}
                  height="24"
                  width="24"
                />
                <span>Careers</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </Link>
            </li>
          ) : (
            ''
          )}
          <li>
            <Link to="/contact-us/">
              <Icon
                className={`${styles.nav_icon}`}
                icon="codicon:mail"
                inline={true}
                height="24"
                width="24"
              />
              <span>Contact Us</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <a
              href="https://goprecise.sharepoint.us/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Icon
                className={`${styles.nav_icon}`}
                icon="carbon:data-vis-1"
                inline={true}
                height="24"
                width="24"
              />
              <span>MyPrecise</span>
              <Icon
                className={`${styles.dropdownArrow__icon} `}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </a>
          </li>
          <li>
            <a
              href="https://precisesystemsinc.sharepoint.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Icon
                className={`${styles.nav_icon}`}
                icon="codicon:gear"
                inline={true}
                height="24"
                width="24"
              />
              <span>MyPrecise&mdash;Technical Solutions</span>
              <Icon
                className={`${styles.dropdownArrow__icon} `}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </a>
          </li>
          <li>
            <Link to="/suppliers/">
              <Icon
                className={`${styles.nav_icon}`}
                icon="codicon:package"
                inline={true}
                height="24"
                width="24"
              />
              <span>Suppliers</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
        </ul>
        {notSitemap ? (
          <section className={styles.navigation__socialMedia}>
            <SocialMedia color="gray" />
          </section>
        ) : (
          ''
        )}
      </div>
      {notSitemap ? (
        <LazyComponentSearch
          location={'/Header/Navigation/Search/Search'}
          nameofClass={styles.navigation__searchBox}
        />
      ) : (
        ''
      )}
    </Fragment>
  )
}
export default SocialLinkList
